<script>
export default {
  name: 'UhAlert',
};
</script>

<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: 'info',
    validator: (value) => ['info', 'warning', 'error'].includes(value),
  },
});

const icons = {
  info: {
    style: 'tw-mb-1 tw-h-5 tw-w-5 tw-p-0 tw-text-sky-500',
    type: 'fa-solid fa-circle-info',
  },
  warning: {
    style: 'tw-mb-1 tw-h-7 tw-w-7 tw-p-0 tw-text-amber-500',
    type: 'fa-solid fa-triangle-exclamation',
  },
  error: {
    style: 'tw-mb-1 tw-h-5 tw-w-5 tw-p-0 tw-text-rose-500',
    type: 'fa-solid fa-circle-exclamation',
  },
};

const variants = {
  info: 'tw-border-sky-500 tw-bg-sky-50 tw-text-sky-700 tw-shadow-sky-500/50',
  warning:
    'tw-border-amber-500 tw-bg-orange-50 tw-text-yellow-700 tw-shadow-amber-500/50',
  error:
    'tw-border-rose-500 tw-bg-red-50 tw-text-pink-700 tw-shadow-rose-500/50',
};
</script>

<template>
  <div
    class="tw-my-4 tw-flex tw-rounded tw-border tw-p-4 tw-text-sm tw-font-bold tw-shadow-sm"
    :class="variants[props.variant]"
    dusk="uh-alert"
  >
    <FontAwesomeIcon
      class="flex-shrink-0 mr-3 tw-inline"
      :class="icons[props.variant].style"
      :icon="icons[props.variant].type"
    />
    <div>
      <slot></slot>
    </div>
  </div>
</template>
